const types = {
  LOAD_COUNTRIES: 'app/country/LOAD_COUNTRIES',
  LOAD_COUNTRIES_SUCCESS: 'app/country/LOAD_COUNTRIES_SUCCESS',
  LOAD_COUNTRIES_FAIL: 'app/country/LOAD_COUNTRIES_FAIL',
};

export default types;
